import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { AllRangePicker } from "../../../components/atoms/formFields/rangePicker/allRangePicker";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import TableLoader from "../../../components/atoms/Loader/tableLoader";
import { reportsAnalyticsOrderThunk } from "../../../store/thunks/reportsAnalyticsThunk";
import VendorStore from "../../../components/atoms/vendorStores";

// Order Component
export default function Order() {
  const dispatch = useDispatch();
  const { data, loading } = useSelector(
    (state) => state?.reportsAnalyticsOrder || {}
  );
  const { storeId } = useSelector((state) => state?.storeData || {});
  const [orderFilter, setOrderFilter] = useState({
    fromDate: "",
    toDate: "",
  });

  useEffect(() => {
    if (storeId) {
      setOrderFilter((prev) => ({
        ...prev,
        inventoryId: storeId,
      }));
    }
  }, [storeId]);

  
  useEffect(() => {
    dispatch(
      reportsAnalyticsOrderThunk({
        orderRequestFilters: {
          paginationFilter: {},
          fromDate: orderFilter?.fromDate,
          toDate: orderFilter?.toDate,
          inventoryId: orderFilter?.inventoryId,
        },
      })
    );
  }, [dispatch, orderFilter]);

  // Returning JSX
  return (
    <>
      <div className="reportcard">
        <div className="d-flex align-items-center bg-gray-300 rounded p-10">
          <div className="d-flex flex-column flex-grow-1 mr-2">
            <p className="font-weight-bold text-dark-75 font-size-h2 mb-1">
              Hi there, welcome to the Reports & Analytics Section.
            </p>
          </div>
          <p className="bg-gray-800 font-size-lg font-weight-bold m-0 p-3 py-1 rounded text-white">
            Total Orders Till Date :
            <span className="font-weight-bolder text-warning pl-2 font-size-lg">
              {data?.ALL_ORDERS}
            </span>
          </p>
        </div>
      </div>

      <div className="d-flex justify-content-between my-5">
        <VendorStore />

        <AllRangePicker
          disabledDate={(current) => {
            return moment().add(0, "days") <= current;
          }}
          onChange={(value, dateString) => {
            if (value) {
              setOrderFilter({
                ...orderFilter,
                fromDate: moment(value[0]["$d"]).format("DD/MM/YYYY"),
                toDate: moment(value[1]["$d"]).format("DD/MM/YYYY"),
              });
            } else {
              setOrderFilter({
                ...orderFilter,
                fromDate: null,
                toDate: null,
              });
            }
          }}
        />
      </div>

      <Row gutter={[24, 24]}>
        {loading ? (
          <TableLoader />
        ) : (
          Object.entries(data || {}).map(([orderStatus, count], i) => {
            if (orderStatus === "ALL_ORDERS") return null;
            const customName = orderStatus === "SHIPPED" ? "IN-TRANSIT" : orderStatus;
            return (
              <Col xs={24} sm={4} key={i.toString()}>
                <div className="card card-custom bgi-no-repeat card-stretch shadow-sm border">
                  <div className="card-body p-5">
                    <div className="d-flex flex-wrap align-items-center">
                      <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                        <p className="text-warning font-weight-bolder font-size-h5 m-0">
                          {customName}
                        </p>
                        <p className="text-success font-weight-bolder font-size-h4 m-0 mt-1">
                          {count}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })
        )}
      </Row>
    </>
  );
}
